import {
  ObjectionBulkUpdateRequest,
  ObjectionsModelRequest
} from '../api/Argentia/endpoints/objections/model/objections'
import {
  apiBulkUpdateObjections,
  apiSaveObjection,
  apiTerminateObjection
} from '../api/Argentia/endpoints/objections/objections.api'
import { ObjectionMasterItem } from '../api/Argentia/endpoints/objectionsMaster/model/objectionsMaster'
import { apiGetObjectionMasters } from '../api/Argentia/endpoints/objectionsMaster/objectionsMaster.api'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../helpers/serviceResponseHelper'
import { ServiceResponse } from '../model/serviceResponse'
import { ObjectionsModel } from '../pages/invoicesPage/invoicesPage.Model'

export const createObjection = async (
  objection: ObjectionsModelRequest
): Promise<ServiceResponse<ObjectionsModel | undefined>> => {
  return await apiSaveObjection(objection)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const terminateObjection = async (
  objectionId: number
): Promise<ServiceResponse<ObjectionsModel[] | undefined>> => {
  return await apiTerminateObjection(objectionId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const bulkUpdateObjections = async (
  data: ObjectionBulkUpdateRequest
): Promise<ServiceResponse<undefined>> => {
  return await apiBulkUpdateObjections(data)
    .then(() => createSuccessServiceResponse(undefined))
    .catch(error => createErrorServiceResponse(error))
}

export const getObjectionMasters = async (
  domain: number
): Promise<ServiceResponse<ObjectionMasterItem[] | undefined>> => {
  return await apiGetObjectionMasters(domain)
    .then(data => createSuccessServiceResponse(data))
    .catch(error => createErrorServiceResponse(error))
}
